import { useQuery } from '@tanstack/react-query'
import { buildSingularResourcefulRequests } from '@utils/requests'
import type { FfpDashboardData } from '@containers/FfpDashboard/types'

export function useFfpDashboardQuery(organizationId: number) {
  const requests = buildSingularResourcefulRequests(`/api/ffp_dashboard?organization_id=${organizationId}`)

  return useQuery<FfpDashboardData, Error>(['ffpDashboard', organizationId], requests.show)
}
